import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useParams, useNavigate, Link } from "react-router-dom";

const Vehicle_position_entry_hire = () => {
useAuthRedirect();
  const navigate = useNavigate();

  const canEntry = hasPermission("Vehicle Delivery Note", "entry");

   const [branches, setBranches] = useState([]);
   const [suppliers, setSuppliers] = useState([]);
   const [uom, setUom] = useState([]);
   const [selectedType, setSelectedType] = useState("");
   const branch = localStorage.getItem("branch");
   const [rows, setRows] = useState([
    { id: 1, description: "", specification: "", uom: "", qty: "", remarks: "" },
  ]);
  const [formData, setFormData] = useState({
    branch: branch,
    toBranch: "",
    supp: "",
    sendThrough: "",
    refNo : "" 
    });
  

  useEffect(() => {
    fetchBranches();
    fetchUom();
  }, []);

    const fetchBranches = async () => {
      try {
        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/deliveryNote_branch");
        setBranches(response.data.branches);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    const fetchUom = async () => {
        try {
          const response = await axios.get("https://rfs2.infraconsoft.net.in/api/delivery_uom");
          setUom(response.data.uom);
        } catch (error) {
          console.error("Error fetching locations:", error);
        }
      };

    useEffect(() => {
        const fetchSuppliers = async () => {
          if (!branch) return;
          try {
            const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/deliveryNote_suppliers?branch_code=${branch}`);
            setSuppliers(response.data.suppliers || []);
            // console.log(response.data.suppliers);
            
          } catch (error) {
            console.error("Error fetching locations:", error);
          }
        };
    
        fetchSuppliers();
      }, [branch]); 

      const handleTypeChange = (e) => {
        setSelectedType(e.target.value);
      };

      // Handle input change for table rows
  const handleRowChange = (index, e) => {
    const { name, value } = e.target;
    const updatedRows = [...rows];
    updatedRows[index][name] = value;
    setRows(updatedRows);

    if (name === "qty" && isNaN(value)) {
      Swal.fire({
          icon: "error",
          title: "Invalid Input",
          text: "Please enter only numbers for Quantity!",
      });
      return;
  }
  };

     // Add new row
  const addRow = () => {
    setRows([...rows, { id: rows.length + 1, description: "", specification: "", uom: "", qty: "", remarks: "" }]);
  };

  const deleteRows = () => {
    setRows(rows.filter((row, index) => !document.getElementById(`checkbox-${index}`).checked));
  };
    

 // Handle input change for form fields
 const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prevData) => ({
    ...prevData,
    [name]: value,
  }));
};

const validateRows = () => {
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    const rowNumber = i + 1;

    // Trim all strings safely
    const desc = (row.description || '').trim();
    const spec = (row.specification || '').trim();
    const uom = (row.uom || '').trim();
    const qty = parseFloat(row.qty);

    if (!desc) {
      Swal.fire({
        icon: "warning",
        title: `Row ${rowNumber}: Missing Description`,
        text: "Please enter the item description.",
      });
      return false;
    }

    if (!spec) {
      Swal.fire({
        icon: "warning",
        title: `Row ${rowNumber}: Missing Specification`,
        text: "Please enter the item specification.",
      });
      return false;
    }

    if (!uom) {
      Swal.fire({
        icon: "warning",
        title: `Row ${rowNumber}: Missing UOM`,
        text: "Please select the Unit of Measurement (UOM).",
      });
      return false;
    }

    if (!row.qty?.toString().trim()) {
      Swal.fire({
        icon: "warning",
        title: `Row ${rowNumber}: Missing Quantity`,
        text: "Please enter the quantity.",
      });
      return false;
    }

    if (isNaN(qty) || qty <= 0) {
      Swal.fire({
        icon: "error",
        title: `Row ${rowNumber}: Invalid Quantity`,
        text: "Quantity must be a valid positive number.",
      });
      return false;
    }
  }

  return true;
};


const handleSubmit = async (e) => {
  e.preventDefault();

    if (!selectedType.trim()) {
            Swal.fire({
              icon: 'warning',
              title: 'Empty Field',
              text: 'Please Select Type!',
            });
            return;
          }

          if(selectedType === 'Supplier') {
              if (!formData.supp.trim()) {
            Swal.fire({
              icon: 'warning',
              title: 'Empty Field',
              text: 'Please Select Your Supplier!',
            });
            return;
          }
          } else {
 if (!formData.toBranch.trim()) {
            Swal.fire({
              icon: 'warning',
              title: 'Empty Field',
              text: 'Please Select To Branch!',
            });
            return;
          }

           if (!formData.refNo.trim()) {
            Swal.fire({
              icon: 'warning',
              title: 'Empty Field',
              text: 'Please Enter your Ref No!',
            });
            return;
          }
          }

         


          if (!formData.sendThrough.trim()) {
            Swal.fire({
              icon: 'warning',
              title: 'Empty Field',
              text: 'Please Enter Send Through!',
            });
            return;
          }

            if (!validateRows()) return;

           
  

  const payload = {
    branch: branch,
    items: rows,
    toBranch: formData.toBranch,
    supp: formData.supp,
    sendThrough: formData.sendThrough,
    refNo: formData.refNo
  };

  console.log("Submitting Payload:", payload);

  try {

       Swal.fire({
                                  title: "Submitting...",
                                  text: "Please wait while we process your request.",
                                  allowOutsideClick: false,
                                  didOpen: () => {
                                    Swal.showLoading();
                                  },
                                });
    


    const response = await axios.post("https://rfs2.infraconsoft.net.in/api/deliveryNote_add", payload);
    console.log(response);
     Swal.fire({
                   title: "Success!",
                   text: "Delivery Note Added successfully.",
                   icon: "success",
                   width: "500px",
                   height: "40vh",
                   draggable: true,
               }).then(() => {
                   navigate("/deliveryNoteVehicle");
               });
         
  } catch (error) {
    Swal.fire("Failed!", "Failed to Disapprove Bill.", "error");
  }
};


if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
        <div className="back-div">
          <h2 className="add-txt">Delivery Note Entry</h2>
          <Link to='/deliveryNoteVehicle'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
        </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container" >
      <form className="vehicle-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label>Select type :</label>
            <select value={selectedType} onChange={handleTypeChange}>
              <option value="">-- Select type --</option>
              <option value="Supplier">Supplier</option>
              <option value="Branch">Branch</option>
            </select>
          </div>
          <div className="form-group">
            <label>Date :</label>
            <input type="date" name="endhrs"  value={new Date().toISOString().split('T')[0]}  readOnly />
          </div>
        </div>

        {/* Supplier fields */}
        {selectedType === "Supplier" && (
          <div className="form-row">
            <div className="form-group">
              <label>Select Supplier :</label>
              <select name="supp" value={formData.supp} onChange={handleChange}  >
        <option value="">-- Select Supplier --</option>
        {suppliers.map((item, index) => (
          <option key={index} value={item.supplierMaster_name}>
            {item.supplierMaster_name}
          </option>
        ))}
      </select>
            </div>
            <div className="form-group">
              <label>Send through :</label>
              <input type="text" name="sendThrough" value={formData.sendThrough} onChange={handleChange} />
            </div>
          </div>
        )}

        {/* Branch fields */}
        {selectedType === "Branch" && (
          <>
            <div className="form-row">
              <div className="form-group">
                <label>From branch :</label>
                <input type="text" name="fromBranch" value={formData.branch || ""} readOnly onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>To branch :</label>
                <select name="toBranch" value={formData.toBranch}  onChange={handleChange}  >
        <option value="">-- Select branch --</option>
        {branches.map((item, index) => (
          <option key={index} value={item.branchMaster_code}>
            {item.branchMaster_name}
          </option>
        ))}
      </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Your Ref. No :</label>
                <input type="text" name="refNo" value={formData.refNo} onChange={handleChange}  />
              </div>
              <div className="form-group">
                <label>Send through :</label>
                <input type="text" name="sendThrough" value={formData.sendThrough} onChange={handleChange}  />
              </div>
            </div>
          </>
        )}

<div className="flex_buttons">
<button type="button" onClick={addRow} className="button button-add">
  Add Row
</button>

<button type="button" onClick={deleteRows} className="button button-delete">
  Delete
</button>
      </div>

      <div className="content-table">
        <table>
          <thead>
            <tr>
              <th>Select</th>
              <th>S.No</th>
              <th>Description</th>
              <th>Specification</th>
              <th>UOM</th>
              <th>Delivery Qty</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td>
                  <input type="checkbox" id={`checkbox-${index}`} />
                </td>
                <td>{index + 1}</td>
                <td>
                  <input type="text" name="description" value={row.description} onChange={(e) => handleRowChange(index, e)} />
                </td>
                <td>
                  <input type="text" name="specification" value={row.specification} onChange={(e) => handleRowChange(index, e)} />
                </td>
                <td>
                  <select name="uom" value={row.uom} onChange={(e) => handleRowChange(index, e)}>
                    <option value="">-- Select UOM --</option>
                    {uom.map((uomm, idx) => (
                      <option key={idx} value={uomm.uommaster_shortname}>
                        {uomm.uommaster_shortname}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <input type="text" name="qty" value={row.qty} onChange={(e) => handleRowChange(index, e)} />
                </td>
                <td>
                  <input type="text" name="remarks" value={row.remarks} onChange={(e) => handleRowChange(index, e)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
            <div className="btn-cls">
          <button type="submit" className="submit-btn">Submit</button>
        </div>
      </form>
    </div>
      </div>
    </div>
  );
};

export default Vehicle_position_entry_hire;